/* global InitialData RegionID MapURL */

import {isAnonymous} from '../utils/html';
import {createReducer} from '../utils/redux';

import {Airport, Map, Marker} from './actions';

const {airports, url: SearchURL} = InitialData;

const initialState = {

    /* Static */
    RegionID,
    isAnonymous,

    /* Settings */
    mapClosed: false,

    /* Markers */
    start: null,
    destination: null,

    /* URLs */
    SearchURL,
    MapURL,

    /* Airports */
    airports,
    active: null,

};

export default createReducer(initialState, {
    [Marker.change]: (state, payload) => payload,
    [Airport.loaded]: (state, airports) => ({airports}),
    [Airport.active]: (state, active) => ({active}),
    [Airport.inactive]: () => ({active: null}),
    [Map.close]: () => ({mapClosed: true}),
    [Map.open]: () => ({mapClosed: false}),
});
